import {Injectable} from '@angular/core';

@Injectable()
export class QrCodeIn {
  imageInBase64: string;
  listStatusOs: any;
  contratoId: number;

  constructor() {
  }
}
